export default __webpack_public_path__ + "8ff80a685fbc14e002c132e11a94ee56.png";